import ApiClient from '../ApiClient';

class MyAiChatThreads extends ApiClient {
  constructor() {
    super('my_ai/my_ai_chat_threads', { accountScoped: true });
  }
}

export default new MyAiChatThreads();
